import { useRef, useCallback } from 'react';

export function useScrollToResult() {
  const resultRefs = useRef<Record<string, HTMLDivElement | null>>({});

  const registerResultRef = useCallback((fileId: string, element: HTMLDivElement | null) => {
    resultRefs.current[fileId] = element;
  }, []);

  const scrollToResult = useCallback((fileId: string) => {
    const element = resultRefs.current[fileId];
    if (element) {
      // Smooth scroll to the element
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });

      // Add temporary highlight effect
      element.classList.add('ring-2', 'ring-primary', 'ring-offset-2');
      setTimeout(() => {
        element.classList.remove('ring-2', 'ring-primary', 'ring-offset-2');
      }, 2000);
    }
  }, []);

  return { registerResultRef, scrollToResult };
}
